import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  name: 'd2-api-base-url-controller',
  data: function data() {
    return {
      active: false,
      custom: 'http://127.0.0.1:8080'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/api', ['base'])), mapGetters('d2admin/api', ['options'])),
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/api', {
    baseUrlSet: 'set',
    baseUrlOptionRemove: 'remove'
  })), {}, {
    onOpen: function onOpen() {
      this.active = true;
    },
    onClose: function onClose() {
      this.active = false;
    },
    onSelect: function onSelect(value) {
      this.baseUrlSet(value);
    },
    onRemove: function onRemove(value) {
      this.baseUrlOptionRemove(value);
    },
    isItemActive: function isItemActive(value) {
      return this.base === value;
    }
  })
};